import React from 'react'
import Loader from 'legacy/libs/components/loader'

import createReactClass from 'create-react-class'

export default function loaderAwareAppComponentFactory(Component) {
  return createReactClass({
    displayName: 'LoaderWrapper',

    render() {
      return (
        <Loader>
          <Component {...this.props} />
        </Loader>
      )
    },
  })
}
